import React, { useState, useEffect } from 'react';
import axios from 'axios';

const durumRenk = {
  hr_onay_bekliyor: 'badge-bekliyor',
  muhasebeci_bekleniyor: 'badge-bekliyor',
  tamamlandi: 'badge-tamamlandi',
  reddedildi: 'badge-hata',
};

const durumEtiket = {
  hr_onay_bekliyor: 'HR Onayı Bekliyor',
  muhasebeci_bekleniyor: 'Muhasebeci Bekleniyor',
  tamamlandi: 'Tamamlandı',
  reddedildi: 'Reddedildi',
};

const fmt = (t) => t ? new Date(t).toLocaleDateString('tr-TR') : '-';

const VizeTaleplerHRPage = () => {
  const [talepler, setTalepler] = useState([]);
  const [filtre, setFiltre] = useState('hr_onay_bekliyor');
  const [kararPanel, setKararPanel] = useState(null);
  const [not, setNot] = useState('');
  const [sonuc, setSonuc] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);

  const yukle = () => axios.get('/api/talepler/hr-onay').then(r => setTalepler(r.data)).catch(console.error);
  useEffect(() => { yukle(); }, []);

  const handleKarar = async (id, karar) => {
    setYukleniyor(true); setSonuc(null);
    try {
      await axios.put('/api/talepler/' + id + '/hr-karar', { karar, not });
      setSonuc({ tip: 'basari', mesaj: karar === 'onaylandi' ? 'Talep onaylandı, muhasebeciye bildirim gönderildi.' : 'Talep reddedildi.' });
      setKararPanel(null);
      setNot('');
      yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata oluştu.' }); }
    finally { setYukleniyor(false); }
  };

  const filtrelenmis = talepler.filter(t => filtre === 'hepsi' ? true : t.durum === filtre);

  return (
    <div>
      <div style={{ marginBottom: '1.5rem' }}>
        <h2 style={{ fontSize: '22px', marginBottom: '4px' }}>Vize Talepleri</h2>
        <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>Personel vize evrak taleplerini onaylayın veya reddedin.</p>
      </div>

      {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1rem' }}>{sonuc.mesaj}</div>}

      <div className="stats-grid" style={{ marginBottom: '1.5rem' }}>
        <div className="stat-kart"><div className="stat-sayi">{talepler.length}</div><div className="stat-etiket">Toplam</div></div>
        <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--sari)' }}>{talepler.filter(t => t.durum === 'hr_onay_bekliyor').length}</div><div className="stat-etiket">Onay Bekliyor</div></div>
        <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--mavi)' }}>{talepler.filter(t => t.durum === 'muhasebeci_bekleniyor').length}</div><div className="stat-etiket">Muhasebede</div></div>
        <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--yesil)' }}>{talepler.filter(t => t.durum === 'tamamlandi').length}</div><div className="stat-etiket">Tamamlandı</div></div>
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: '1rem 1.25rem', borderBottom: '1px solid var(--border)', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          {[
            { key: 'hr_onay_bekliyor', label: 'Onay Bekleyenler' },
            { key: 'muhasebeci_bekleniyor', label: 'Muhasebede' },
            { key: 'tamamlandi', label: 'Tamamlananlar' },
            { key: 'reddedildi', label: 'Reddedilenler' },
            { key: 'hepsi', label: 'Hepsi' },
          ].map(f => (
            <button key={f.key} className={'btn btn-sm ' + (filtre === f.key ? 'btn-primary' : 'btn-secondary')} onClick={() => setFiltre(f.key)}>
              {f.label}
            </button>
          ))}
        </div>

        {filtrelenmis.length === 0 ? (
          <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--yazi-ikincil)' }}>Talep bulunamadı.</div>
        ) : (
          <div className="tablo-wrapper">
            <table>
              <thead>
                <tr><th>Personel</th><th>Gidilecek Ülke</th><th>İzin Tarihleri</th><th>Durum</th><th>Tarih</th><th>İşlem</th></tr>
              </thead>
              <tbody>
                {filtrelenmis.map(t => (
                  <React.Fragment key={t.id}>
                    <tr>
                      <td>
                        <div style={{ fontWeight: '500' }}>{t.ad} {t.soyad}</div>
                        <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>{t.personel_email}</div>
                      </td>
                      <td style={{ fontWeight: '500' }}>{t.gidilecek_ulke}</td>
                      <td style={{ fontSize: '13px' }}>{fmt(t.izin_baslangic)} — {fmt(t.izin_bitis)}</td>
                      <td><span className={'badge ' + (durumRenk[t.durum] || 'badge-bekliyor')}>{durumEtiket[t.durum] || t.durum}</span></td>
                      <td style={{ fontSize: '13px' }}>{fmt(t.olusturma_tarihi)}</td>
                      <td>
                        {t.durum === 'hr_onay_bekliyor' && (
                          <button className="btn btn-secondary btn-sm" onClick={() => { setKararPanel(kararPanel === t.id ? null : t.id); setNot(''); }}>
                            Karar Ver
                          </button>
                        )}
                      </td>
                    </tr>
                    {kararPanel === t.id && (
                      <tr>
                        <td colSpan={6} style={{ background: 'var(--gri-50)', padding: '1rem' }}>
                          <div className="form-group" style={{ marginBottom: '0.75rem' }}>
                            <label>Not (isteğe bağlı)</label>
                            <input type="text" value={not} onChange={e => setNot(e.target.value)} placeholder="Açıklama ekleyin..." />
                          </div>
                          <div style={{ display: 'flex', gap: '8px' }}>
                            <button className="btn btn-primary" disabled={yukleniyor} onClick={() => handleKarar(t.id, 'onaylandi')}>✓ Onayla</button>
                            <button className="btn btn-danger" disabled={yukleniyor} onClick={() => handleKarar(t.id, 'reddedildi')}>✗ Reddet</button>
                            <button className="btn btn-secondary" onClick={() => setKararPanel(null)}>İptal</button>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};
export default VizeTaleplerHRPage;
